export default __webpack_public_path__ + "static/media/image-mp4-file.78a59c8d.svg";